// extracted by mini-css-extract-plugin
var _1 = "ra-cms-trust-section";
var _2 = "ra-cms-trust-section-item-footer";
var _3 = "ra-cms-trust-section-item";
var _4 = "ra-cms-trust-section-item-icon";
var _5 = "ra-cms-trust-section-text";
export { _1 as "trustSectionCls", _2 as "trustSectionFooterCls", _3 as "trustSectionItemCls", _4 as "trustSectionItemIconCls", _5 as "trustSectionTextCls" }
